const getRichTextStateFromMessage = (richTextState: Strapi.RichTextState): boolean => {
  return (
    richTextState?.root?.children?.length === 0
    || richTextState?.root?.children?.some((node) => node?.children?.length !== 0) === false
  )
}

export default getRichTextStateFromMessage
